import { render, staticRenderFns } from "./AccordionTransition.vue?vue&type=template&id=cf34460e"
import script from "./AccordionTransition.vue?vue&type=script&lang=js"
export * from "./AccordionTransition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports